import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Constrains content width so text never spans a full monitor.
 * Full-bleed sections opt out by sitting outside a Container.
 */
const Container: React.FC<ContainerProps> = ({ children, className = '' }) => (
  <div className={'w-full max-w-container mx-auto lg:px-10 ' + className}>
    {children}
  </div>
);

export default Container;
